import React, {Component} from 'react'
import {observer} from 'mobx-react'

import Tree from '../../../control/Tree'

import * as ProfileCatalogEntityType from '../../../../constant/ProfileCatalogEntityType'

@observer export default class EntitySelect extends Component {
    render() {
        const context = this.props.context
        /** @type {CatalogEntity} */
        const entity = this.props.entity

        if (entity.type === ProfileCatalogEntityType.CATEGORY) {
            return (
                <Tree
                    nodes={context.categories}
                    node_type="category"
                    entity={entity}
                    state={context.form_state}
                />
            )
        }

        if (entity.type === ProfileCatalogEntityType.PRODUCTS_TYPE) {
            return (
                <Tree
                    nodes={context.product_types}
                    entity={entity}
                    state={context.form_state}
                />
            )
        }

        if (entity.type === ProfileCatalogEntityType.PRODUCTS_SET) {
            return (
                <Tree
                    nodes={context.sets}
                    entity={entity}
                    state={context.form_state}
                />
            )
        }

        console.warn(`неизвестный тип ${entity.type}`)

        return null
    }
}